export const BASEURL = 'https://munimanstripe.codeguidesserver.de';